import { extend, localize } from 'vee-validate';
import {
  required as rule_required,
  email as rule_email,
  min as rule_min,
  min_value as rule_min_value,
  max as rule_max,
  max_value as rule_max_value,
  confirmed as rule_confirmed,
  regex as rule_regex,
  between as rule_between,
  alpha as rule_alpha,
  integer as rule_integer,
  digits as rule_digits,
  alpha_dash as rule_alpha_dash,
  alpha_num as rule_alpha_num,
  length as rule_length,
} from 'vee-validate/dist/rules';
import ar from 'vee-validate/dist/locale/ar.json';
import en from 'vee-validate/dist/locale/en.json';
import vi from 'vee-validate/dist/locale/vi.json';

// eslint-disable-next-line object-curly-newline
import {
  validatorPositive,
  validatorUrlValidator,
  validatorPassword,
  validatorPasswordNormal,
  validatorCreditCard,
  validatorAlphaNumDash,
  validatorAlphaNumDot,
  validatorAlphaNumDotDash,
  validatorTag,
  validatorNumber,
  validatorNumberMinOne,
  validatorNumberMinZero,
} from './validators';

// ////////////////////////////////////////////////////////
// General
// ////////////////////////////////////////////////////////

export const required = extend('required', rule_required);

export const email = extend('email', rule_email);

export const min = extend('min', rule_min);

export const minValue = extend('min-value', rule_min_value);

export const max = extend('max', rule_max);

export const maxValue = extend('max-value', rule_max_value);

export const confirmed = extend('confirmed', rule_confirmed);

export const regex = extend('regex', rule_regex);

export const between = extend('between', rule_between);

export const alpha = extend('alpha', rule_alpha);

export const integer = extend('integer', rule_integer);

export const digits = extend('digits', rule_digits);

export const alphaDash = extend('alpha-dash', rule_alpha_dash);

export const alphaNum = extend('alpha-num', rule_alpha_num);

export const numberMinOne = extend('number-min-one', {
  validate: validatorNumberMinOne,
  message: 'Vui lòng nhập số dương và phải lớn hơn 1',
});
export const numberMinZero = extend('number-min-zero', {
  validate: validatorNumberMinZero,
  message: 'Vui lòng nhập số dương và phải lớn hơn 0',
});
export const alphaNumDot = extend('alpha-num-dot', {
  validate: validatorAlphaNumDot,
  message: '{_field_} chỉ cho phép nhập chữ cái, số và dấu chấm',
});

export const tag = extend('tag', {
  validate: validatorTag,
  message: '{_field_} chỉ cho phép nhập chữ cái, số và dấu cách',
});
export const alphaNumDotOrDash = extend('alpha-num-dot-or-dash', {
  validate: validatorAlphaNumDotDash,
  message: '{_field_} chỉ cho phép nhập chữ cái, số và gạch chân',
});
export const alphaNumUnderscore = extend('alpha-num-underscore', {
  validate: validatorAlphaNumDash,
  message: '{_field_} chỉ cho phép nhập chữ cái, số và gạch chân',
});

export const length = extend('length', rule_length);

export const positive = extend('positive', {
  validate: validatorNumber,
  message: 'Vui lòng nhập số dương!',
});

export const number = extend('number', {
  validate: validatorPositive,
  message: 'Vui lòng nhập số!',
});

export const credit = extend('credit-card', {
  validate: validatorCreditCard,
  message: 'Đây không phải là thẻ tín dụng hợp lệ!',
});

export const strongPassword = extend('strong-password', {
  validate: validatorPassword,
  // message: 'Your {_field_} must contain at least one uppercase, one lowercase, one special character and one digit',
});
export const mediumPassword = extend('medium-password', {
  validate: validatorPasswordNormal,
  // message: 'Your {_field_} must contain at least one uppercase, one lowercase, one special character and one digit',
});
export const url = extend('url', {
  validate: validatorUrlValidator,
  message: 'URL is invalid',
});

// console.log(vi.messages);
// Install English and Arabic localizations.
localize({
  vi: {
    messages: {
      ...vi.messages,
      'alpha-num': vi.messages.alpha_num,
      'alpha-dash': vi.messages.alpha_dash,
      integer: '{_field_} chỉ cho phép nhập chữ số',
      // 'alpha-num-dot': '{_field_} chỉ cho phép nhập chữ cái, số và dấu chấm',
      min: '{_field_} phải có ít nhất {length} kí tự',
      max: '{_field_} có nhiều nhất {length} kí tự',
      'strong-password': 'Mật khẩu của bạn phải chứa ít nhất một chữ hoa, một chữ thường, một ký tự đặc biệt và một chữ số',
      'medium-password': 'Mật khẩu của bạn phải chứa ít nhất một ký tự đặc biệt',
      'min-value': 'Tối thiểu {min}',
      'max-value': 'Tối đa {min}',
    },
    names: {
      email: 'Email',
      password: 'Mật khẩu',
      confirm_password: 'Mật khẩu xác nhận',
      captcha: 'Mã bảo mật',
      username: 'Tài khoản',
      full_name: 'Họ và tên',
      phone_number: 'Số điện thoại',
      date_of_birth: 'Ngày sinh',
      role: 'Vai trò',
    },
    fields: {
      password: {
        'strong-password': 'Mật khẩu của bạn phải chứa ít nhất một chữ hoa, một chữ thường, một ký tự đặc biệt và một chữ số',
        'medium-password': 'Mật khẩu của bạn phải chứa ít nhất một ký tự đặc biệt',
      },
      confirm_password: {
        confirmed: 'Mật khẩu xác nhận không trùng khớp',
      },
    },
  },
  en: {
    messages: en.messages,
    names: {
      email: 'Email',
      password: 'Password',
    },
    fields: {
      password: {
        min: '{_field_} is too short, you want to get hacked?',
      },
    },
  },
  ar: {
    messages: ar.messages,
    names: {
      email: 'البريد الإلكتروني',
      password: 'كلمة السر',
    },
    fields: {
      password: {
        min: 'كلمة السر قصيرة جداً سيتم اختراقك',
      },
    },
  },
});
localize('vi');
// ////////////////////////////////////////////////////////
// NOTE:
// Quasar validation for reference only
// Remove this note once development is finished and make sure to
// to convert all of them in veevalidate version
// ////////////////////////////////////////////////////////

// export const required = (val) => {
//   return (val && val.length > 0) || '*Field is required'
// }

// export const required_obj = (obj) => {
//   if (obj === null || obj === undefined) return '*Field is required'
//   return (Object.entries(obj).length > 0 && obj.constructor === Object) || '*Field is required'
// }

// export const no_blank_spaces_arr = (arr) => {
//   return arr.every(val => (val.trim() && val.trim().length > 0)) || 'Blank Spaces are not allowed'
// }

// export const url = val => {
//   // If blank return
//   if (val === undefined || val === null || val.length === 0) return true

//   // Used
//   // https://stackoverflow.com/questions/4314741/url-regex-validation

//   // Other
//   // https://stackoverflow.com/questions/5717093/check-if-a-javascript-string-is-a-url
//   // https://www.w3resource.com/javascript-exercises/javascript-regexp-exercise-9.php
//   // https://www.geeksforgeeks.org/how-to-validate-url-using-regular-expression-in-javascript/

//   /* eslint-disable no-useless-escape */
//   const re = /^(http[s]?:\/\/){0,1}(www\.){0,1}[a-zA-Z0-9\.\-]+\.[a-zA-Z]{2,5}[\.]{0,1}/
//   /* eslint-enable no-useless-escape */
//   return re.test(val) || 'URL is invalid'
// }

// export const date = val => {

//   // If blank return
//   if (val === undefined || val === null || val.length === 0) return true

//   // https://github.com/quasarframework/quasar/blob/dev/ui/src/utils/patterns.js
//   return /^-?[\d]+\/[0-1]\d\/[0-3]\d$/.test(val) || 'Date is invalid'
// }

// export const max = (val, max) => {

//   // If blank return
//   if (val === undefined || val === null) return true

//   return val.length <= max || `More than ${max} characters are not allowed`
// }

// export const max_arr = (val, max) => {
//   return val.length <= max || `More than ${max} values are not allowed`
// }

// export const min = (val, min) => {

//   // If blank return
//   if (val === undefined || val === null || val.length === 0) return true

//   return val.length >= min || `Minimum ${min} characters are required`
// }

// export const num_range = (val, min, max) => {

//   // If blank return
//   if (val === undefined || val === null || val.length === 0) return true

//   const msg = 'Value is invalid'
//   if (min === null) return val <= max || msg
//   else if (max === null) return val >= min || msg
//   else return (val >= min && val <= max) || msg
// }
